import { UseFormReturn } from "react-hook-form";
import { RestaurantFormData } from "@/types/restaurantForm";
import { RestaurantNameField } from "./fields/RestaurantNameField";
import { AddressField } from "./fields/AddressField";
import { NeighborhoodField } from "./fields/NeighborhoodField";

interface BasicInfoFieldsProps {
  form: UseFormReturn<RestaurantFormData>;
  restaurantId?: number;
}

export const BasicInfoFields = ({ form, restaurantId }: BasicInfoFieldsProps) => {
  return (
    <>
      <RestaurantNameField form={form} />
      <AddressField form={form} restaurantId={restaurantId} />
      <NeighborhoodField form={form} />
    </>
  );
};